import { __assign, __rest } from "tslib";
import React, { useCallback } from 'react';
import { fieldReducers, getFieldDisplayName, reduceField } from '@grafana/data';
import { AxisPlacement } from './config';
import { VizLayout } from '../VizLayout/VizLayout';
import { mapMouseEventToMode } from '../GraphNG/utils';
import { VizLegend } from '../VizLegend/VizLegend';
var defaultFormatter = function (v) { return (v == null ? '-' : v.toFixed(1)); };
export var PlotLegend = function (_a) {
    var data = _a.data, config = _a.config, onSeriesColorChange = _a.onSeriesColorChange, onLegendClick = _a.onLegendClick, placement = _a.placement, calcs = _a.calcs, displayMode = _a.displayMode, vizLayoutLegendProps = __rest(_a, ["data", "config", "onSeriesColorChange", "onLegendClick", "placement", "calcs", "displayMode"]);
    var onLegendLabelClick = useCallback(function (legend, event) {
        var fieldIndex = legend.fieldIndex;
        if (!onLegendClick || !fieldIndex) {
            return;
        }
        onLegendClick({
            fieldIndex: fieldIndex,
            mode: mapMouseEventToMode(event),
        });
    }, [onLegendClick]);
    var legendItems = config
        .getSeries()
        .map(function (s) {
        var _a, _b;
        var seriesConfig = s.props;
        var fieldIndex = seriesConfig.dataFrameFieldIndex;
        var axisPlacement = config.getAxisPlacement(s.props.scaleKey);
        if (seriesConfig.hideInLegend || !fieldIndex) {
            return undefined;
        }
        var field = (_a = data[fieldIndex.frameIndex]) === null || _a === void 0 ? void 0 : _a.fields[fieldIndex.fieldIndex];
        if (!field) {
            return undefined;
        }
        var label = getFieldDisplayName(field, data[fieldIndex.frameIndex]);
        return {
            disabled: (_b = !seriesConfig.show) !== null && _b !== void 0 ? _b : false,
            fieldIndex: fieldIndex,
            color: seriesConfig.lineColor,
            label: label,
            yAxis: axisPlacement === AxisPlacement.Left ? 1 : 2,
            getDisplayValues: function () {
                var _a;
                if (!(calcs === null || calcs === void 0 ? void 0 : calcs.length)) {
                    return [];
                }
                var fmt = (_a = field.display) !== null && _a !== void 0 ? _a : defaultFormatter;
                var fieldCalcs = reduceField({
                    field: field,
                    reducers: calcs,
                });
                return calcs.map(function (reducer) {
                    return __assign(__assign({}, fmt(fieldCalcs[reducer])), { title: fieldReducers.get(reducer).name });
                });
            },
            getItemKey: function () { return label + "-" + fieldIndex.frameIndex + "-" + fieldIndex.fieldIndex; },
        };
    })
        .filter(function (i) { return i !== undefined; });
    return (React.createElement(VizLayout.Legend, __assign({ placement: placement }, vizLayoutLegendProps),
        React.createElement(VizLegend, { onLabelClick: onLegendLabelClick, placement: placement, items: legendItems, displayMode: displayMode, onSeriesColorChange: onSeriesColorChange })));
};
PlotLegend.displayName = 'PlotLegend';
//# sourceMappingURL=PlotLegend.js.map